<template>
	<div ref="codemirror" style="flex: 1;"></div>
</template>

<script>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';
import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/sql/sql'; // 引入SQL模式
import 'codemirror/addon/search/searchcursor'; // 引入搜索光标插件
import { format } from 'sql-formatter'; // 引入SQL格式化库

export default {
	name: 'CodeEditor',
	props: {
		modelValue: {
			type: String,
			required: true
		},
		options: {
			type: Object,
			default: () => ({})
		},
		highlightWordConfigs: {
			type: Array,
			default: () => []
		}
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const codemirror = ref(null);
		let editor = null;

		const formatSQL = () => {
			const formattedSQL = format(editor.getValue());
			editor.setValue(formattedSQL);
		};

		const highlightText = () => {
			if (editor) {
				editor.getAllMarks().forEach(mark => mark.clear()); // 清除所有标记
				props.highlightWordConfigs.forEach(word => {
					const from = {
						'line': word.line,
						'ch': word.from,
					}
					const to = {
						'line': word.line,
						'ch': word.to,
					}

					editor.markText(from, to, {
						className: 'highlighted'
					});
				});
			}
		};

		onMounted(() => {
			editor = CodeMirror(codemirror.value, {
				value: props.modelValue,
				mode: 'text/x-sql',
				lineNumbers: true,
				...props.options
			});

			editor.on('change', () => {
				const value = editor.getValue();
				emit('update:modelValue', value);
			});

			highlightText();
		});

		watch(() => props.modelValue, (newValue) => {
			if (editor && newValue !== editor.getValue()) {
				editor.setValue(newValue);
			}
		});

		watch(() => props.highlightWordConfigs, () => {
			highlightText();
		});

		onBeforeUnmount(() => {
			if (editor) {
				editor.toTextArea();
			}
		});

		return {
			codemirror,
			formatSQL
		};
	}
};
</script>

<style scoped>
/* 可选：添加样式来调整 CodeMirror 的显示 */

button {
	margin-top: 10px;
}
</style>
